import {Checkbox, Form} from 'antd';
import {NamePath} from 'antd/es/form/interface';

import {Text} from '../../../../../../component/text/text';

import * as styles from './export-template-additional-data-fields.module.scss';

type PropsType<FormType> = {
    disabled?: boolean;
    reviewsSummaryName: NamePath<FormType>;
    tagsStatName: NamePath<FormType>;
    showReviewsSummary?: boolean;
    showTagsStat?: boolean;
};

export function ExportTemplateAdditionalDataFields<FormType>(props: PropsType<FormType>): JSX.Element {
    const {disabled, reviewsSummaryName, tagsStatName, showReviewsSummary = true, showTagsStat = true} = props;

    return (
        <Form.Item<FormType>
            className={styles.ExportTemplateAdditionalDataFields}
            label={<Text lighter stringKey="REVIEWS__DOWNLOAD_REPORT_POPUP__ADDITIONAL_DATA__LABEL__TITLE" />}
        >
            <div className={styles.ExportTemplateAdditionalDataFields_checkboxRow}>
                {showReviewsSummary ? (
                    <Form.Item<FormType> initialValue={false} name={reviewsSummaryName} noStyle valuePropName="checked">
                        <Checkbox disabled={disabled}>
                            <Text stringKey="REVIEWS__DOWNLOAD_REPORT_POPUP__REVIEW_STATISTICS_BY_BRAND_AND_CITY__FEEDBACK_REPORT" />
                        </Checkbox>
                    </Form.Item>
                ) : null}
                {showTagsStat ? (
                    <Form.Item<FormType> initialValue={false} name={tagsStatName} noStyle valuePropName="checked">
                        <Checkbox disabled={disabled}>
                            <Text stringKey="REVIEWS__DOWNLOAD_REPORT_POPUP__REVIEW_STATISTICS_BY_BRAND_AND_CITY__TAG_REPORT" />
                        </Checkbox>
                    </Form.Item>
                ) : null}
            </div>
        </Form.Item>
    );
}
